import React from 'react';
import Grid from '@material-ui/core/Grid';
import { ResetPasswordForm } from '../components';
import { withRouter } from 'react-router-dom';
import '../../../assets/styles/auth-module.scss';

function ResetPassword(props) {
  return (
    <section className="user-authentication-section">
      <Grid
        container
        spacing={0}
        alignItems="center"
        justify="center"
        className="user-form-wrapper"
        style={{ height: window.innerHeight - 80 }}
      >
        <ResetPasswordForm />
      </Grid>
    </section>
  );
}
export default withRouter(ResetPassword);
